module.exports = __webpack_public_path__ + "static/engagement_banner@2x.dec1632f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/engagement_banner@2x.png
// module id = 653
// module chunks = 193162123475590